import { axiosInstance } from "../../../axios/axiosInstance";

const API_DASHBOARD_URL = "admin/dashboard/";
const API_SEND_PUSH_NOTIFICATION_URL = API_DASHBOARD_URL + "send-push";

export const sendPushNotification = (dataToBeSent) => {
  return axiosInstance.post(API_SEND_PUSH_NOTIFICATION_URL, dataToBeSent);
};
